// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"da2b4769","643":"afcf705b","766":"fb12a368"}[chunkId] + ".chunk.js";
};